/**
 * Thrown instead of a plain alert when the backend refuses (409) to deactivate a
 * point category because it is the last active category of some points.
 *
 * The store stays UI-agnostic: only the screen knows whether it can offer the
 * fallback picker (the category page does, the list row does not), so it decides
 * what to tell the admin. Re-throw it so the row switch rolls back.
 */
export class FallbackCategoryRequiredError extends Error {
  constructor(readonly orphanPointsCount: number) {
    super('Fallback category required');
    this.name = 'FallbackCategoryRequiredError';
  }
}
